var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDummy2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "comment",
    transform: "translate(1.000000, 1.000000)",
    stroke: "#000000",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.625,5.25 C11.625,2.5575 9.1065,0.375 6,0.375 C2.8935,0.375 0.375,2.5575 0.375,5.25 C0.375,7.9425 2.8935,10.125 6,10.125 C6.39375,10.125 6.77775,10.089 7.149,10.02225 L10.125,11.625 L10.125,8.55675 C11.0535,7.6875 11.625,6.528 11.625,5.25 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDummy2);
export default __webpack_public_path__ + "static/media/dummy2.debd3f4b94edfa099346d6cc4c1d7e6f.svg";
export { ForwardRef as ReactComponent };